"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionDropdownListItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
function ActionDropdownListItem({ highlightedIndex, index, item, getItemProps }) {
    var _a;
    const actionDropdownItemLabel = item.label;
    const actionDropdownOnClick = item.onClick;
    // Icon is an optional field so if there is no icon provided use Null
    const ActionDropdownIcon = (_a = item.icon) !== null && _a !== void 0 ? _a : null;
    return ((0, jsx_runtime_1.jsxs)("li", Object.assign({ className: (0, classnames_1.default)('text-body-small', 'pl-4', 'pr-10', 'py-2', 'cursor-pointer', 'flex', 'items-center', {
            'bg-silver-5 text-blue-80': highlightedIndex === index,
            'text-silver-90': highlightedIndex !== index,
            'bg-silver-10 text-silver-50': item.disabled
        }) }, getItemProps({
        item,
        index,
        onClick: actionDropdownOnClick,
        disabled: item.disabled
    }), { children: [ActionDropdownIcon && ((0, jsx_runtime_1.jsx)(ActionDropdownIcon, { size: 16, className: "inline mr-2" })), actionDropdownItemLabel] })));
}
exports.ActionDropdownListItem = ActionDropdownListItem;
//# sourceMappingURL=ActionDropdownListItem.js.map